import { Inject, Injectable } from '@angular/core';

import { Environment, DivisioniRu, IDruICanModel, IDruListIsErrorModel } from '../../models/-index';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class DivisioniRuService extends CrudGenericsService<DivisioniRu, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/DivisioniRu`);
    this.base = `${env.apiUrl}/api/DivisioniRu/`;
  }

  // non usata ???  in notifiche
  GetAdmins_ByDivisione_DRU(div: string): Observable<DivisioniRu[]> {
    const u = this.base + 'GetAdmins_ByDivisione_DRU?div=' + div;
    return this.http.get<DivisioniRu[]>(`${u}`);
  }
  // in form utenti
  Get_ByUtente_DRU(uid: string): Observable<DivisioniRu[]> {
    const u = this.base + 'Get_ByUtente_DRU?uid=' + uid;
    return this.http.get<DivisioniRu[]>(`${u}`);
  }
  // in form utenti
  GetAllCombinazioni_DivisioneRuolo(azb: number): Observable<DivisioniRu[]> {
    if (azb == null) {
      azb = 0;
    }
    const u = `${this.base}GetAllCombinazioni_DivisioneRuolo?azb=${azb}`;
    return this.http.get<DivisioniRu[]>(u);
  }

  // ritorna tutte le divisione ru dell'utente e della divisione selezionata
  GetSigle_ByUtenteByDivisione_DRU(uid: string, div: string): Observable<DivisioniRu> {
    const u = this.base + 'GetSigle_ByUtenteByDivisione_DRU?uid=' + uid + '&div=' + div;
    return this.http.get<DivisioniRu>(`${u}`);
  }
  // ritorna le divisioni ru dell'utente distinte per divisione la maggiore se è Admin altrimenti la prima User
  Get_ByUtente_DistinctDRU(uid: string): Observable<DivisioniRu[]> {
    const u = this.base + 'Get_ByUtente_DistinctDRU?uid=' + uid;
    return this.http.get<DivisioniRu[]>(`${u}`);
  }

  Get_ByUtenteByDivisione_DRU(uid: string, div: string): Observable<DivisioniRu[]> {
    const u = this.base + 'Get_ByUtenteByDivisione_DRU?uid=' + uid + '&div=' + div;
    return this.http.get<DivisioniRu[]>(`${u}`);
  }
  // in user form
  GetAll_returnDruICanModel(): Observable<IDruICanModel[]> {
    const u = this.base + 'GetAll_returnDruICanModel';
    return this.http.get<IDruICanModel[]>(`${u}`);
  }
  // in user form
  Get_ByUtente_returnDruICanModel(id: string): Observable<IDruICanModel[]> {
    const u = this.base + 'Get_ByUtente_returnDruICanModel?id=' + id;
    return this.http.get<IDruICanModel[]>(`${u}`);
  }
  // in user form cerca diritti in AD
  SearchInAD_GetDruListIsErrorModel(domain: string, uname: string): Observable<IDruListIsErrorModel> {
    const u = this.base + 'SearchInAD_GetDruListIsErrorModel?domain=' + domain + '&uname=' + uname;
    return this.http.get<IDruListIsErrorModel>(`${u}`);
  }
  // ritorna tutte le divisione ru dell'utente e della divisione selezionata

  /*
  Get_ByUtenteByDivisione_DRU_IncludeAzienda(uid: string, div: string, h: boolean = false): Observable<DivisioniRu[]> {
    const u = this.base + 'Get_ByUtenteByDivisione_DRU_IncludeAzienda?uid=' + uid + '&div=' + div + '&h=' + h;
    return this.http.get<DivisioniRu[]>(`${u}`);
  }*/
}
